import React from "react";
import InputForm from "../../generales/InputForm";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
import Action from "../../Action";
import { useState ,useEffect} from 'react';
import Modal from "react-modal";
import ModalLinKHost from "../ModalLinKHost";
import "./ConfirmAction.css";
import LoadSimple from "../../LoadSimple";
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const ConfirmAction = ({
    groups_catalog,
          location_catalog,
          services_catalog,
          brands_catalog,
          models_catalog,
    hostSelected,editActive,dataCis,cisData,languaje,closHostsModal,Registrar,loading}) => {
    const labels = {
      ip: "IP",
      hostid: "Host ID",
      ci_group_id: "Grupo CI",
      name: "Nombre",
      affiliation: "Afiliación",
      description: "Descripción",
      location_id: "Ubicación",
      service_id: "Servicio",
      brand_id: "Marca",
      model_id: "Modelo",
      version: "Versión",
      serial_no: "Número de serie",
      mac: "MAC",
      request_user: "Usuario solicitante",
      auth_user: "Usuario autorizado",
      user_comment: "Comentario",
    };
    const cambios = Object.keys(cisData).reduce((acc, key) => {
      const nuevo = cisData[key];
      const actual = dataCis[key];

      // Si son iguales, no lo agregamos
      if (nuevo === actual) return acc;

      acc.push({
        field: key,
        old: actual,
        new: nuevo
      });

      return acc;
    }, []);
    function traductor_id(attr, value) {
        switch (attr) {
            case 'ci_group_id': {
                
                  const item = groups_catalog.data.data.find(el => el.id === value);
                 return item ? item.name : null;
            }
            case 'location_id': {
                
               const item = location_catalog.data.data.find(el => el.id === value);
                 return item ? item.name : null;
            }
            case 'service_id': {
                
                const item = services_catalog.data.data.find(el => el.cassia_tech_service_id === value);
                 return item ? item.service_name : null;
            }
            case 'brand_id': {
                
                
               const item = brands_catalog.data.data.find(el => el.brand_id === value);
                 return item ? item.name_brand : null;
            }
            case 'model_id': {
                const item = models_catalog.data.data.find(el => el.model_id === value);
                return item ? item.name_model : null;
            }
            default: {
                return value;
            }
        }
    }
    return (
        <>
            <div className="confirm-action-container">
                <div className="compact-confirm-action">
                    <div className="confirm-action-titulo">
                        {'Confirmar '+((editActive)?'Edición':'Creación')+' del Registro de configuración '} 
                    </div>
                    <div className="confirm-action-body">
                        {(cisData.ip==undefined || cisData.ip==null || cisData.ip=="")?'':<div className="cont-msg-alert-confirm-action">
                            <div className="compact-msg-alert-confirm-action">
                                <img  className='icon-msg-alert' src={"/iconos/warning.png"}alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                                <div className="msg-alert-txt-confirm-action">

                                    {(editActive)?
                                        'El CI que está modificando está vinculado a un dispositivo monitoreado. Los cambios que realice se verán reflejados también en los datos del dispositivo.':
                                        'Al vincular un dispositivo a un CI, se enlazaran los datos del dispositivo con el CI. Los cambios que realice se verán reflejados en el dispositivos'
                                        }
                                </div>
                            </div>
                            
                        </div>}
                        <div className="cont-msg-confirm-action">
                            <div className="compact-msg-confirm-action">
                                <div className="msg-alert-txt-confirm-action">
                                    {(editActive)?<><p>{'Se esta editando el CI con Folio ' +dataCis.folio+' asignando los siguients datos. '}</p><p>{'Se detectaron ('+(cambios.length-3)+') cambios'}</p></>:'Se Creara el siguiente registro de configuración con los datos indicados: '}
                                </div>
                            </div>
                            
                        </div>
                        <div className="cont-datos-confirm-action">
                            <div className="compact-datos-confirm-action">
                                {(editActive)?cambios.map(item => (
                                        // <p key={item.field}>
                                        //     <strong>{labels[item.field] }: </strong>
                                        //     {(item.old==undefined || item.old==null || item.old=="")?"Vacio":item.old} → {item.new}
                                        // </p>
                                        (<div className="row-change-confirm-action" key={item.field}>
                                            <div className="label-confirm-action-title"><strong>{labels[item.field] + ': '}</strong></div>
                                            <div className="change-values-confirm-action">
                                               {(item.field=='user_comment' || item.field=='auth_user' || item.field=='request_user')?'':<> <div className="old-value-confirm-action" title={(item.old==undefined || item.old==null || item.old=="")?"Vacio":item.old}>
                                                    {(item.old==undefined || item.old==null || item.old=="")?"Vacio":traductor_id(item.field,item.old)}
                                                </div>
                                                <div className="arrow-change-confirm-action">→</div></>}
                                                <div className="new-value-confirm-action" title={item.new}>
                                                    {traductor_id(item.field,item.new)}
                                                </div>
                                            </div>
                                        </div>)
                                    )):Object.entries(cisData)
                                    .filter(([key, value]) => value !== null && value !== "") // solo valores con info
                                    .map(([key, value]) => (
                                        <p key={key}>
                                        <strong style={{ color: 'var(--third-color)' }}>
                                            {labels[key] + ': '}
                                        </strong>
                                        {value}
                                        </p>
                                    ))
                                    } 
                                   
                                {/* <p><strong style={{color:'var(--third-color)'}}>{'Alias: '}</strong> {cisData.affiliation}</p>
                                <p><strong>{'Nombre: '}</strong> {cisData.name}</p>
                                <p><strong>{'Descripción: '}</strong> {cisData.description}</p>      */}
                            </div>
                        </div>
                    </div>
                    <div className="confirm-action-footer">
                        <div className="cont-buttons-panel" style={{width:'60%', display:'flex',right:'unset',top:'unset'} }>
                                         {
                                          
                                          (loading)?<LoadSimple></LoadSimple>:
                                           
                                          <>
                                          <Action
                                          disabled={false}
                                          origen="Azul"
                                          titulo={capitalizeFirstLetter(lang[languaje]['aceptar'])}
                                          action={()=>{Registrar()}}
                                        />
                                        <Action
                                        disabled={false}
                                        origen="Cancelar"
                                        titulo={""+capitalizeFirstLetter(lang[languaje]['cancelar'])}
                                        action={()=>{ closHostsModal() }}
                                      />
                                          </>
                                          
                                         }
                                            
                                          
                                            
                                        </div>
                                        { (loading)?
                                      <div className='cont-btn-modal-delete' style={{color:'var(--txt-color)'}}>
                                            Esto puede tomar unos segundos, porfvor espere...
                                          
                                    </div>:''
                                    }
                    </div>
                </div>
            </div>
        </>
    );
}

export default ConfirmAction;
 